<script lang="ts">
    import { page } from '$app/stores';
    import { isFirstPageLoad } from '$lib/Stores/stores';

    import { onMount } from 'svelte';

    import { getTransitionData } from './helper';

    import type { TransitionEffect } from '$lib/types/Theme';

    export let delay = 0;
    export let effect: TransitionEffect = 'default';
    export let fullHeight = false;

    let ready = false;

    onMount(() => (ready = true));

    // Optionally skip the staggered block entrance on the initial cold load when the
    // funnel opts in via `theme.disableAnimationOnPageLoad`. The per-index delay would
    // otherwise defer the LCP element even when the main thread and network are idle
    // (FUN-3928). Off by default, so live funnels keep their current entrance animation.
    // In-funnel navigation is unaffected — `isFirstPageLoad` flips on the first
    // client-side navigation. Suppression reuses the existing `none` effect (no delay,
    // zero duration), so blocks paint immediately at full opacity.
    $: skipEntrance = $isFirstPageLoad && !!$page?.data?.theme?.disableAnimationOnPageLoad;
    $: activeEffect = skipEntrance ? 'none' : effect;

    $: ({ transitionFunction, transitionProps } = getTransitionData(activeEffect));
</script>

{#if ready}
    <div
        class:fun-h-full={fullHeight}
        in:transitionFunction={{ ...transitionProps, delay: activeEffect === 'none' ? 0 : delay }}
    >
        <slot />
    </div>
{/if}
